import { render, staticRenderFns } from "./el-date.vue?vue&type=template&id=0be645e5&lang=pug&"
import script from "./el-date.vue?vue&type=script&lang=ts&"
export * from "./el-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports